import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import a from "./util/net.js";
import ue from "./models/braze-event.js";
import c from "./common/event-logger.js";
import { randomInclusive as l } from "./util/math.js";
import H from "./models/request-result.js";
import { logger as E, IndexedDBAdapter as et, Guid as P, EventTypes as m } from "../shared-lib/index.js";
import { STORAGE_KEYS as s } from "./managers/storage-manager.js";
import u from "./managers/subscription-manager.js";
import yt from "./Push/utils/push-utils.js";
import h from "./util/request-header-utils.js";
var Wt = /*#__PURE__*/function () {
  function Wt(t, i, s, e, h, n, o, r, l, a) {
    _classCallCheck(this, Wt);
    this.sn = t, this.baseUrl = i, this.C = s, this.on = e, this.Cs = h, this.h = n, this.j = o, this.$l = r, this.Qh = l, this.B = a, this.sn = t, this.baseUrl = i, this.Tl = 0, this.fE = o.dE() || 0, this.Ll = null, this.C = s, this.on = e, this.Cs = h, this.h = n, this.j = o, this.Qh = l, this.B = a, this.$l = r, this.Ml = new u(), this.Pl = null, this.Il = 50, this.Ol = !1, this.Ul = !1;
  }
  _createClass(Wt, [{
    key: "_l",
    value: function _l(t, i) {
      return !t && !i && this.Qh.Hh() >= this.Il;
    }
  }, {
    key: "Jl",
    value: function Jl(t) {
      var i = this.C.zl();
      if (t.length > 0) {
        var _s = this.Cs.getUserId();
        var _iterator = _createForOfIteratorHelper(t),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var e = _step.value;
            var _t = !e.userId && !_s || e.userId === _s;
            e.type === m.Al && _t && (i = !0);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return i;
    }
  }, {
    key: "Kl",
    value: function Kl() {
      var _this = this;
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var e = arguments.length > 2 ? arguments[2] : undefined;
      var n = arguments.length > 3 ? arguments[3] : undefined;
      var o = arguments.length > 4 ? arguments[4] : undefined;
      var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
      var u = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
      i && this.Xl();
      var c = this.j.RE(),
        d = this.j.IE();
      var m = !1;
      var f = function f(t, r) {
          var u = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
          var c = new Date().valueOf();
          h.K(_this.j, h.H.Tu, c), -1 !== u && r.push(["X-Braze-Req-Tokens-Remaining", u.toString()]);
          var d = !1;
          a.O({
            url: _this.baseUrl + "/data/",
            data: t,
            headers: r,
            W: function W(i) {
              null != t.respond_with && t.respond_with.triggers && (_this.Tl = Math.max(_this.Tl - 1, 0)), _this.B.Y(t, i, r) ? (_this.Qh.Z(), _this.h.cl(i), null != t.respond_with && t.respond_with.user_id != _this.Cs.getUserId() || (null != t.device && _this.j.ft(s.ct.Qa, t.device), null != t.sdk_metadata && (_this.j.ft(s.ct.au, t.sdk_metadata), _this.j.ft(s.ct.du, _this.C.bt())), _this.$l(i), h.Bu(_this.j, h.H.Tu, 1), "function" == typeof e && e())) : i.auth_error && (d = !0);
            },
            error: function error() {
              d = !0, null != t.respond_with && t.respond_with.triggers && (_this.Tl = Math.max(_this.Tl - 1, 0)), _this.B.fu(t.events, t.attributes), "function" == typeof n && n();
            },
            tt: function tt(t, s) {
              "function" == typeof o && o(!d);
              var e = _this.B.Fu(s);
              var n = 0;
              if (e) switch (e.type) {
                case "date":
                  n = Math.max(e.value - new Date().valueOf(), 0);
                  break;
                case "timestamp":
                  n = e.value;
              }
              if (i && !m) {
                if (d) {
                  h.Ku(_this.j, h.H.Tu);
                  var _t2 = _this.Ll;
                  (null == _t2 || _t2 < 1e3 * _this.fE) && (_t2 = 1e3 * _this.fE);
                  var _i = Math.min(3e5, l(1e3 * _this.fE, 3 * _t2)) + n;
                  _this.Ql(_i);
                } else _this.Ql(Math.max(1e3 * _this.fE, n));
                m = !0;
              }
            }
          });
        },
        g = this.Jl(c),
        v = t || g;
      if (this._l(r, g)) return void E.info("Declining to flush data due to 50 consecutive authentication failures");
      if (i && !this.B.Au(c, d, v)) return this.Ql(), void ("function" == typeof o && o(!0));
      var p = this.B.Du(v, c, d, u);
      v && this.Tl++;
      var b = !1;
      if (p) {
        var _iterator2 = _createForOfIteratorHelper(p),
          _step2;
        try {
          var _loop = function _loop() {
            var t = _step2.value;
            _this.B.J(t.requestData, function (i) {
              return f(t.requestData, t.headers, i);
            }, h.H.Tu, n), b = !0;
          };
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      this.Qh.fh() && i && !b ? this.Ql() : g && (E.info("Invoking new session subscriptions"), this.Ml.L(), this.Ul = !0);
    }
  }, {
    key: "Yl",
    value: function Yl() {
      return this.Tl > 0;
    }
  }, {
    key: "Ql",
    value: function Ql() {
      var _this2 = this;
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e3 * this.fE;
      this.Ol || (this.Xl(), this.Pl = window.setTimeout(function () {
        if (document.hidden) {
          var _t3 = "visibilitychange",
            i = function i() {
              document.hidden || (document.removeEventListener(_t3, i, !1), _this2.Kl());
            };
          document.addEventListener(_t3, i, !1);
        } else _this2.Kl();
      }, t), this.Ll = t);
    }
  }, {
    key: "Xl",
    value: function Xl() {
      null != this.Pl && (clearTimeout(this.Pl), this.Pl = null);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.Ol = !1, this.Ql();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.Ml.removeAllSubscriptions(), this.Qh.Bh(), this.Xl(), this.Ol = !0, this.Kl(void 0, !1, void 0, void 0, void 0, void 0, !0), this.Pl = null, this.Ul = !1;
    }
  }, {
    key: "rn",
    value: function rn(t) {
      return this.Ul ? (t(), null) : this.Ml.wt(t);
    }
  }, {
    key: "openSession",
    value: function openSession() {
      var _this3 = this;
      var t = this.C.bt() !== this.C.qo();
      t && (this.j.hE(s.iu.Jh), this.j.hE(s.iu.su)), this.Kl(!1, void 0, function () {
        _this3.j.Nt(s.ct.qe);
      }), this.zn(), t && import("./Push/push-manager-factory.js").then(function (t) {
        if (_this3.Ol) return;
        var i = t["default"].ea();
        if (null != i && (yt.isPushPermissionGranted() || yt.isPushBlocked())) {
          var _t4 = function _t4() {
              i.mn() ? E.info("Push token maintenance is disabled, not refreshing token for backend.") : i.subscribe();
            },
            e = function e(i, s) {
              s && _t4();
            },
            _h = function _h() {
              var i = _this3.j.lt(s.ct.In);
              (null == i || i) && _t4();
            },
            n = et.Us.Rs;
          new et(n, E).jr(n.Fs.cu, e, _h);
        }
      });
    }
  }, {
    key: "Zl",
    value: function Zl() {
      this.j.Nt(s.ct.Ie), this.j.Nt(s.ct.Ps), this.j.Nt(s.ct.Nr);
    }
  }, {
    key: "hc",
    value: function hc() {
      var t, i;
      this.j.Nt(s.ct.Lu), this.j.Nt(s.ct.SE);
      var e = h.H;
      for (var _i2 in e) {
        var _s2 = e[_i2];
        this.B.Uu(_s2, null === (t = this.h) || void 0 === t ? void 0 : t.Vu(_s2));
      }
      this.B.Iu(null === (i = this.h) || void 0 === i ? void 0 : i.Ju());
    }
  }, {
    key: "changeUser",
    value: function changeUser(t, i, e) {
      var h = this.Cs.getUserId();
      if (h !== t) {
        this.C.Bl(), this.Zl(), null != h && this.Kl(void 0, !1, void 0, void 0, void 0), this.Cs.ou(t), e ? this.Qh.setSdkAuthenticationSignature(e) : this.Qh.qh();
        for (var _t5 = 0; _t5 < i.length; _t5++) i[_t5].changeUser(null == h);
        this.B.fo(), null != h && this.j.Nt(s.ct.rE), this.j.Nt(s.ct.Qa), this.j.Nt(s.ct.uE), this.hc(), this.openSession(), E.info('Changed user to "' + t + '".');
      } else {
        var _i3 = "Doing nothing.";
        e && this.Qh.wh() !== e && (this.Qh.setSdkAuthenticationSignature(e), _i3 = "Updated SDK authentication signature"), E.info("Current user is already ".concat(t, ". ").concat(_i3));
      }
    }
  }, {
    key: "requestImmediateDataFlush",
    value: function requestImmediateDataFlush(t) {
      this.Xl(), this.C.qo();
      this.Kl(void 0, void 0, void 0, function () {
        E.error("Failed to flush data, request will be retried automatically.");
      }, t, !0);
    }
  }, {
    key: "$r",
    value: function $r(t, i) {
      this.C.qo(), E.info("Requesting explicit trigger refresh."), this.Kl(!0, void 0, t, i);
    }
  }, {
    key: "En",
    value: function En(t, i) {
      var e = m.nc,
        h = {
          a: t,
          l: i
        },
        n = c.rt(e, h);
      return n && (E.info("Logged alias ".concat(t, " with label ").concat(i)), this.j.ft(s.ct.uE, h)), n;
    }
  }, {
    key: "Ln",
    value: function Ln(t, i, s) {
      if (this.h.hu(i)) return E.info("Custom Attribute \"".concat(i, "\" is blocklisted, ignoring.")), new H();
      var e = {
          key: i,
          value: s
        },
        h = c.rt(t, e);
      if (h) {
        var _t6 = "object" == typeof s ? JSON.stringify(s, null, 2) : s;
        E.info("Logged custom attribute: ".concat(i, " with value: ").concat(_t6));
      }
      return h;
    }
  }, {
    key: "setLastKnownLocation",
    value: function setLastKnownLocation(t, i, s, e, h, n) {
      var o = {
        latitude: i,
        longitude: s
      };
      null != e && (o.altitude = e), null != h && (o.ll_accuracy = h), null != n && (o.alt_accuracy = n);
      var r = c.rt(m.lc, o, t || void 0);
      return r && E.info("Set user last known location as ".concat(JSON.stringify(o, null, 2))), r;
    }
  }, {
    key: "kr",
    value: function kr(t, i) {
      var s = this.C.qo();
      return new ue(this.Cs.getUserId(), m.uc, t, s, {
        cid: i
      });
    }
  }, {
    key: "cc",
    value: function cc(t, i) {
      return new et(t, i);
    }
  }, {
    key: "zn",
    value: function zn() {
      var t = et.Us.Rs;
      this.cc(t, E).setItem(t.Fs.Tu, 1, {
        baseUrl: this.baseUrl,
        data: {
          api_key: this.sn,
          device_id: this.on.fe().id
        },
        userId: this.Cs.getUserId(),
        sdkAuthEnabled: this.Qh.fh()
      });
    }
  }, {
    key: "yr",
    value: function yr(t) {
      var _iterator3 = _createForOfIteratorHelper(t),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var i = _step3.value;
          if (i.api_key === this.sn) this.B.fu(i.events, i.attributes);else {
            var _t7 = et.Us.Rs;
            new et(_t7, E).setItem(_t7.Fs.wr, P.oe(), i);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "Hn",
    value: function Hn(t, i, s) {
      if (this.h.hu(t)) return E.info("Custom Attribute \"".concat(t, "\" is blocklisted, ignoring.")), new H();
      var e, h;
      return null === i && null === s ? (e = m.dc, h = {
        key: t
      }) : (e = m.mc, h = {
        key: t,
        latitude: i,
        longitude: s
      }), c.rt(e, h);
    }
  }, {
    key: "Kn",
    value: function Kn(t, i) {
      var s = {
        group_id: t,
        status: i
      };
      return c.rt(m.fc, s);
    }
  }]);
  return Wt;
}();
export { Wt as default };